import React, { FC, useState } from "react";
import classes from "./LicenseHasExpiredModal.module.scss";
import { useAddLicense } from "../../../hooks/license/useAddLicense";
import Typography, { TypographyVariant } from "../../Typography/Typography";
import { CustomTextField } from "../../Admin/CustomTextField/CustomTextField";
import { Button } from "../../Admin/Button/Button";

export const LicenseKeySection: FC = () => {
  const [keyValue, setKeyValue] = useState("");
  const { addLicense, isAddLicensePending } = useAddLicense(true);

  return (
    <div
      className={classes.licenseKeySectionContainer}
      onClick={(e) => e.stopPropagation()}
    >
      <Typography
        variant={TypographyVariant.h4_regular}
        className={classes.message}
      >
        Ключ продления лицензии:
      </Typography>

      <CustomTextField
        value={keyValue}
        onChange={(e) => setKeyValue(e.target.value)}
        placeholder="Введите новый ключ"
        labelName={"Новый ключ"}
        isLicense
      />

      <div className={classes.confirmButtonsContainer}>
        <Button
          content="Подтвердить"
          btnStyle={"blue"}
          onClick={() => {
            addLicense({ key: keyValue });
          }}
          isDisabled={!keyValue || isAddLicensePending}
          isLoading={isAddLicensePending}
        />
      </div>
    </div>
  );
};
